export default "__VITE_ASSET__DvBhAHn3__"